function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { getSpacingSelector } from '@signal/theme';
import Typography from '../Typography';
var gutterBottomSelector = getSpacingSelector(1.5);
export var labelStyles = function labelStyles(theme) {
  return {
    gutterBottom: {
      marginBottom: gutterBottomSelector(theme)
    }
  };
};
export var LabelBase = /*#__PURE__*/memo(function (_ref) {
  var classes = _ref.classes,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body1' : _ref$variant,
      rest = _objectWithoutProperties(_ref, ["classes", "variant"]);

  return /*#__PURE__*/React.createElement(Typography, Object.assign({
    variant: variant,
    muiClasses: classes
  }, rest));
});
export var Label = withStyles(labelStyles)(LabelBase);